$(window).bind("load", function () {
      if (($('footer .success').length) || ($('footer .errors').length)) {
            
         //   $("#footer-signup form").css("width", "100%");

 $('html, body').animate({scrollTop: $("footer").offset().top -10}, 500);
      }
  
      if ($(this).width() == 980) {
        $('body').removeClass('shifter-enabled'); 
      }
  
      if ($('#cart').height() > 50) {
        $('li.shifter-handle h5').css({ "display": "inline-block", "padding-left": "5px" })
      }
      else {
        $('li.shifter-handle h5').css("display", "none");
      }
  
      if ($(this).width() >= 386) {
        $('li.shifter-handle h5').css("display", "none");
      }
  
});


// EQUAL HEIGHT COLLECTION
equalheight = function(container){

    var currentTallest = 0,
         currentRowStart = 0,
         rowDivs = new Array(),
         $el,
         topPosition = 0;
     $(container).each(function() {
    
       $el = $(this);
       $($el).height('auto')
       topPostion = $el.position().top;
    
       if (currentRowStart != topPostion) {
         for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
           rowDivs[currentDiv].height(currentTallest);
         }
         rowDivs.length = 0; // empty the array
         currentRowStart = topPostion;
         currentTallest = $el.height();
         rowDivs.push($el);
       } else {
         rowDivs.push($el);
         currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
      }
       for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
         rowDivs[currentDiv].height(currentTallest);
       }
     });
    }
    
    $(window).load(function() {
      equalheight('#product-loop .prod-container');
    });
    
    $(window).resize(function(){
      equalheight('#product-loop .prod-container');
    });
    

    // fix bug where header covers logo etc
    $(window).scroll(function() {
      var scrollTop = $(this).scrollTop();
      if (scrollTop <= 0) {
        $('#nav').css("top", "unset");
      } 
    });

$(function () {
  $(window).bind("resize", function () {
    
      if ($(this).width() == 980) {
      $('body').removeClass('shifter-enabled');
      }
    
    var CartHeight = $('#cart').height();
     // if ($('#cart').height() >= 90) {
      if (CartHeight > 50) {
        $('li.shifter-handle h5').css({ "display": "inline-block", "padding-left": "5px" })
      }
      else {
        $('li.shifter-handle h5').css("display", "none");
      }
    
    if ($(this).width() >= 386) {
      $('li.shifter-handle h5').css("display", "none");
    }

    if ($(this).width() < 980) {
      if ($('.gridlock.shifter.page.shifter-enabled').length) {
      }
      else {
        $('body').addClass('shifter-enabled');
      }
    }

  })
})


jQuery(function() {
    $('.single-option-selector').on('change', function(){
        setTimeout(function(){ 
          if($('[name="id"]').val() != "{{ product.selected_or_first_available_variant.id }}"){
            location.reload();
          }
        }, 1);
    });
  });